/**
 * PDP-integration: event wiring og orkestrering. Forretningsregler: HFCProductDomain.
 * Orderability-/m²-DOM: HFCProductPdpOrderabilityUi / HFCProductPdpM2CalculatorUi.
 * Variant on-sale picker: HFCProductPdpVariantSaleUi (ADR-002).
 */
document.addEventListener('DOMContentLoaded', () => {
    handle_product_page();
});

function handle_product_page() {
    on_content_loaded();
    add_quantity_listeners();
    add_calculator_square_meter_listener();
    add_order_sample_click_listener();
    initialize_buy_button_icon();
    bind_variant_change_discount_handler();
    bind_pdp_orderability_submit_guard();
    ensure_canonical_price_dom_observer();
}

function bind_pdp_orderability_submit_guard() {
    var template = document.querySelector('.product-template');
    if (!template) {
        return;
    }
    template.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
        if (form.dataset.hfcOrderabilitySubmitGuard === '1') {
            return;
        }
        form.dataset.hfcOrderabilitySubmitGuard = '1';
        form.addEventListener('submit', function (ev) {
            var V = window.HFCProductPdpVariants;
            var ob_ui = window.HFCProductPdpOrderabilityUi;
            if (!V || !ob_ui || typeof ob_ui.getOrderability !== 'function') {
                return;
            }
            var variant = typeof V.getCurrentVariant === 'function'
                ? V.getCurrentVariant()
                : (typeof V.resolveSelectedVariant === 'function' ? V.resolveSelectedVariant() : null);
            var ob = ob_ui.getOrderability(variant);
            if (ob && ob.fulfillment_state === 'out_of_stock_non_backorderable') {
                ev.preventDefault();
                ev.stopPropagation();
            }
        }, true);
    });
}

function schedule_pdp_variant_derived_ui(trusted_variant) {
    var run = function () {
        try {
            var V = window.HFCProductPdpVariants;
            var v = trusted_variant ||
                (V && typeof V.resolveSelectedVariant === 'function' ? V.resolveSelectedVariant() : null) ||
                (V && typeof V.getCurrentVariant === 'function' ? V.getCurrentVariant() : null);
            var variants = V && typeof V.getProductVariants === 'function' ? V.getProductVariants() : [];
            var sale_ui = window.HFCProductPdpVariantSaleUi;
            if (variants.length > 1 && sale_ui && typeof sale_ui.applyVariantOptionSaleToDom === 'function') {
                sale_ui.applyVariantOptionSaleToDom(v);
            }
            var obUi = window.HFCProductPdpOrderabilityUi;
            if (obUi && typeof obUi.applyOrderabilityToDom === 'function') {
                obUi.applyOrderabilityToDom(v);
            }
            apply_canonical_pricing_to_dom(v, false);
            var m2 = window.HFCProductPdpM2CalculatorUi;
            if (m2 && typeof m2.ensureOrderSampleButtonState === 'function') {
                m2.ensureOrderSampleButtonState();
            }
        } catch (e) {
            console.warn('pdp variant ui sync failed', e);
        }
    };
    run();
}

function initialize_buy_button_icon() {
    var buy_button_el = document.querySelector('.main-product__block-buy_buttons .add-to-cart');
    if (!buy_button_el) {
        return;
    }
    var icon_marker = 'data-cart-icon-initialized';
    if (buy_button_el.hasAttribute(icon_marker) || buy_button_el.querySelector('.pdp-atc-cart-icon')) {
        return;
    }
    var cart_icon = '<svg class="w-[20px] h-[20px] inline ml-1 shrink-0 pdp-atc-cart-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor" aria-hidden="true"><path d="M256 144L256 192L384 192L384 144C384 108.7 355.3 80 320 80C284.7 80 256 108.7 256 144zM208 240L144 240L144 496L496 496L496 240L432 240L432 320L384 320L384 240L256 240L256 320L208 320L208 240zM208 192L208 144C208 82.1 258.1 32 320 32C381.9 32 432 82.1 432 144L432 192L544 192L544 544L96 544L96 192L208 192z"/></svg>';
    buy_button_el.innerHTML = buy_button_el.innerHTML + cart_icon;
    buy_button_el.setAttribute(icon_marker, 'true');
}

function bind_variant_change_discount_handler() {
    try {
        var dom_product_id_el = document.querySelector('[data-product-id]');
        var dom_product_id = dom_product_id_el ? dom_product_id_el.getAttribute('data-product-id') : null;
        var shopify_pid = window.shopify_product && window.shopify_product.id ? window.shopify_product.id : null;
        var bound_product_id = shopify_pid || dom_product_id;
        if (window.MinimogEvents && bound_product_id) {
            var product_event = bound_product_id + '__VARIANT_CHANGE';
            if (typeof window.MinimogEvents.subscribe === 'function') {
                window.MinimogEvents.subscribe(product_event, function (variant) {
                    try {
                        var enriched_variant = (window.shopify_product && Array.isArray(window.shopify_product.variants))
                            ? window.shopify_product.variants.find(function (vv) {
                                return String(vv.id) === String(variant && variant.id);
                            })
                            : null;
                        try {
                            window._last_selected_variant_id = (enriched_variant || variant) && (enriched_variant || variant).id;
                        } catch (e) { /* noop */ }
                        var trusted_variant = enriched_variant || variant;
                        schedule_pdp_variant_derived_ui(trusted_variant);
                    } catch (e) {
                        console.warn('variant change pricing handler failed', e);
                    }
                });
            }
        }
    } catch (e) {
        console.warn('failed to bind variant change discount handler', e);
    }
}

function ensure_canonical_price_dom_observer() {
    var ui = window.HFCProductPdpPricingUi;
    if (ui && typeof ui.ensureCanonicalPriceDomObserver === 'function') {
        ui.ensureCanonicalPriceDomObserver();
    }
}

function apply_canonical_pricing_to_dom(passed_variant, should_fade) {
    if (should_fade === void 0) {
        should_fade = false;
    }
    var ui = window.HFCProductPdpPricingUi;
    if (ui && typeof ui.applyCanonicalPricingToDom === 'function') {
        ui.applyCanonicalPricingToDom(passed_variant, should_fade);
    }
}

function on_content_loaded() {
    var V = window.HFCProductPdpVariants;
    var variants = V && typeof V.getProductVariants === 'function' ? V.getProductVariants() : [];
    var current_variant = V && typeof V.resolveSelectedVariant === 'function'
        ? V.resolveSelectedVariant()
        : (V && typeof V.getCurrentVariant === 'function' ? V.getCurrentVariant() : null);
    var obUi = window.HFCProductPdpOrderabilityUi;
    var sale_ui = window.HFCProductPdpVariantSaleUi;
    if (variants.length > 1 && sale_ui && typeof sale_ui.applyVariantOptionSaleToDom === 'function') {
        sale_ui.applyVariantOptionSaleToDom(current_variant);
    }
    if (obUi && typeof obUi.applyOrderabilityToDom === 'function') {
        obUi.applyOrderabilityToDom(current_variant);
    }
    var m2 = window.HFCProductPdpM2CalculatorUi;
    if (m2 && typeof m2.ensureOrderSampleButtonState === 'function') {
        m2.ensureOrderSampleButtonState();
    }
    if (current_variant && document.querySelector('.main-product__block.main-product__block-price .f-price')) {
        try {
            apply_canonical_pricing_to_dom(current_variant, false);
        } catch (e) { /* noop */ }
    }
}

function add_quantity_listeners() {
    var quantity_input = document.querySelector('.quantity-input__element');
    if (!quantity_input) {
        return;
    }
    var m2 = window.HFCProductPdpM2CalculatorUi;
    quantity_input.addEventListener('change', function (event) {
        if (m2 && typeof m2.onQuantityInputChange === 'function') {
            m2.onQuantityInputChange(event.target.value);
        }
    });
    quantity_input.addEventListener('input', function (event) {
        if (m2 && typeof m2.onQuantityInputChange === 'function') {
            m2.onQuantityInputChange(event.target.value);
        }
    });
}

function add_calculator_square_meter_listener() {
    var calc_quantity_input = document.querySelector('#m2_input_square_meters');
    if (!calc_quantity_input) {
        return;
    }
    var m2 = window.HFCProductPdpM2CalculatorUi;
    calc_quantity_input.addEventListener('input', function () {
        var calc_quantity_value = document.querySelector('#total_packs_span');
        if (calc_quantity_value && m2 && typeof m2.onQuantityInputChange === 'function') {
            m2.onQuantityInputChange(calc_quantity_value.innerHTML);
        }
    });
}

function add_order_sample_click_listener() {
    var btn = document.querySelector('#order_sample_button');
    if (!btn) {
        return;
    }
    btn.addEventListener('click', function () {
        fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                var items = data.items || [];
                var filtered_items = items.filter(function (item) {
                    return item.id === 45714342117682;
                });
                var total_quantity = filtered_items.reduce(function (sum, item) {
                    return sum + item.quantity;
                }, 0);
                if (total_quantity < 3) {
                    var V = window.HFCProductPdpVariants;
                    var cv = V && typeof V.getCurrentVariant === 'function' ? V.getCurrentVariant() : null;
                    add_sample_order(cv);
                }
            })
            .catch(function (error) {
                console.error('Error:', error);
            });
    });
}

function get_full_product_variant(callback) {
    var current_product = window.location.pathname.split('/')[2];
    var V = window.HFCProductPdpVariants;
    var current_variant = V && typeof V.getCurrentVariant === 'function' ? V.getCurrentVariant() : null;
    fetch(window.Shopify.routes.root + 'products/' + current_product + '.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            var full_variant = data.variants.find(function (variant) {
                return variant.id == current_variant.id;
            });
            callback(full_variant);
        })
        .catch(function (error) {
            console.error('Error:', error);
        });
}

function add_sample_order(product_variant) {
    var add_to_cart_form = document.querySelector('form.main-product-form');
    if (!add_to_cart_form) {
        return;
    }
    var product_quantity_input = add_to_cart_form.querySelector('input[name="quantity"]');
    if (!product_variant || !product_quantity_input) {
        return;
    }
    var d = window.HFCProductDomain;
    var product = window.shopify_product || {};
    var displayProps = {
        Farve: product_variant.color ? product_variant.color : '',
        Overflade: product_variant.size ? product_variant.size : '',
        Størrelse: product_variant.surface ? product_variant.surface : '',
        SKU: product_variant.sku ? product_variant.sku : '',
    };
    var built = d && typeof d.buildSampleLineProperties === 'function'
        ? d.buildSampleLineProperties(product_variant, product, displayProps)
        : Object.assign({}, displayProps);
    var sample_product_data = {
        id: 45714342117682,
        properties: built,
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(sample_product_data),
    })
        .then(function () {
            product_quantity_input.value = 0;
            window.Shopify.onItemAdded(0);
        })
        .catch(function (error) {
            console.error('Error:', error);
        });
}
